import { render, staticRenderFns } from "./ResolTt2_1d01.vue?vue&type=template&id=b0dec338&"
import script from "./ResolTt2_1d01.vue?vue&type=script&lang=js&"
export * from "./ResolTt2_1d01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports